import axios from 'axios';

let griffinMetadata;

export function requestMetadata() {
  return axios.get('/smarthelp/getGriffinMetadata').then((response) => {
    griffinMetadata = response.data;
  });
}

export function getMetadata() {
  return griffinMetadata;
}
